// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"355":"1e6c52b017362d7366f3","494":"d6fd091f6450dc30876e","960":"1796123ec8ad9d33addf"}[chunkId] + ".js";
};